import { rgb, StandardFonts } from 'pdf-lib';

export const handbookPdf = async (pdfDoc, data) => {
  // Replace [name]
  const pages = pdfDoc.getPages();
  const page = pages[0];
  const secondPage = pages[1];
  const thirtyEightPage = pages[37];
  const fourtyTwoPage = pages[41];
  const fourtyFivePage = pages[44];
  const fourtySixPage = pages[45];
  const fourtyNinePage = pages[48];
  const sixtyTwoPage = pages[61];
  const sixtyThree = pages[62];
  const fourtyPage = pages[39];
  const fourtyFourPage = pages[43];
  const sixtyFourPage = pages[63];
  const sixtySevenPage = pages[66];
  const sixtyEightPage = pages[67];
  const sixtyNinePage = pages[68];
  const { width, height } = page.getSize();

  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const boldfont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
  const courierBold = await pdfDoc.embedFont(StandardFonts.CourierBold);

  const dspIndexes = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 38, 39, 40, 41];
  const allCompIndexes = [
    13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
    37, 42, 43, 44, 45, 46, 47, 48, 49, 51, 52, 53, 56, 57, 58, 59, 60, 61, 62, 63,
  ];

  const dspXMap = {
    2: 355,
    3: 355,
    4: 355,
    5: 355,
    6: 355,
    7: 180,
    8: 238,
    9: 238,
    10: 238,
    11: 238,
    12: 170,
    38: 322,
    39: 322,
    40: 322,
    41: 192,
  };

  const allCompXMap = {
    13: 255,
    14: 214,
    15: 214,
    16: 214,
    17: 285,
    18: 285,
    19: 285,
    20: 205,
    21: 198,
    22: 198,
    23: 198,
    24: 283,
    25: 283,
    26: 283,
    27: 283,
    28: 283,
    29: 283,
    30: 283,
    31: 310,
    32: 310,
    33: 310,
    34: 205,
    35: 205,
    36: 205,
    37: 226,
    42: 250,
    43: 250,
    44: 250,
    45: 250,
    46: 250,
    47: 250,
    48: 250,
    49: 250,
    51: 211,
    52: 211,
    53: 270,
    56: 280,
    57: 228,
    58: 226,
    59: 347,
    60: 252,
    61: 203,
    62: 203,
    63: 203,
  };

  pages.forEach((page, index) => {
    if (dspIndexes.includes(index)) {
      page.drawRectangle({
        x: dspXMap[index], // X position of the background
        y: height - 52, // Y position of the background
        width: 50, // Width of the background box (adjust as needed)
        height: 15, // Height of the background box (adjust as needed)
        color: rgb(1, 1, 1), // White color
      });
      page.drawText(data.DSP_TRADENAME, {
        x: dspXMap[index], // X position of the placeholder
        y: height - 48, // Y position of the placeholder
        size: 11, // Text size
        color: rgb(0, 0, 0),
        lineHeight: 14,
        font: boldfont,
        maxWidth: width / 1.3,
      });
    }
    if (allCompIndexes.includes(index)) {
      page.drawRectangle({
        x: allCompXMap[index], // X position of the background
        y: height - 52, // Y position of the background
        width: 80, // Width of the background box (adjust as needed)
        height: 15, // Height of the background box (adjust as needed)
        color: rgb(1, 1, 1), // White color
      });
      page.drawText(data.DSP_TRADENAME, {
        x: allCompXMap[index], // X position of the placeholder
        y: height - 48, // Y position of the placeholder
        size: 11, // Text size
        color: rgb(0, 0, 0),
        lineHeight: 14,
        font: boldfont,
        maxWidth: width / 1.3,
      });
    }
  });

  fourtySixPage.drawRectangle({
    x: 72, // X position of the background
    y: height - 621, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 30, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  if (data?.DRUG_PROCEDURE) {
    fourtySixPage.drawText(data?.DRUG_PROCEDURE, {
      x: 72, // X position of the placeholder
      y: height - 615, // Y position of the placeholder
      size: 11, // Text size
      color: rgb(0, 0, 0),
      lineHeight: 14,
      font: font,
      maxWidth: width / 1.3,

      // letterSpacing: 0.5,
    });
  }
  // fourtyFivePage.drawRectangle({
  //   x: 72, // X position of the background
  //   y: height - 580, // Y position of the background
  //   width: width - 140, // Width of the background box (adjust as needed)
  //   height: 20, // Height of the background box (adjust as needed)
  //   color: rgb(1, 1, 1), // White color
  // });

  if (data?.PRESCRIPTION) {
    fourtyFivePage.drawText(data?.PRESCRIPTION, {
      x: 72, // X position of the placeholder
      y: height - 575, // Y position of the placeholder
      size: 11, // Text size
      color: rgb(0, 0, 0),
      lineHeight: 14,
      font: boldfont,
      maxWidth: width / 1.3,

      // letterSpacing: 0.5,
    });
  }
  // fourtyNinePage.drawRectangle({
  //   x: 72, // X position of the background
  //   y: height - 480, // Y position of the background
  //   width: width - 140, // Width of the background box (adjust as needed)
  //   height: 20, // Height of the background box (adjust as needed)
  //   color: rgb(1, 1, 1), // White color
  // });

  if (data?.NOTIFICATION_POLICY) {
    fourtyNinePage.drawText(data?.NOTIFICATION_POLICY, {
      x: 72, // X position of the placeholder
      y: height - 460, // Y position of the placeholder
      size: 11, // Text size
      color: rgb(0, 0, 0),
      lineHeight: 14,
      font: boldfont,
      maxWidth: width / 1.3,

      // letterSpacing: 0.5,
    });
  }

  page.drawRectangle({
    x: 72, // X position of the background
    y: height - 170, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 20, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  page.drawText(data.DSP_TRADENAME, {
    x: width / 2.9, // X position of the placeholder
    y: height - 150, // Y position of the placeholder
    size: 24, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font: boldfont,
    maxWidth: width / 1.3,

    // letterSpacing: 0.5,
  });
  //
  secondPage.drawRectangle({
    x: 252, // X position of the background
    y: height - 106, // Y position of the background
    width: 196, // Width of the background box (adjust as needed)
    height: 13, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  secondPage.drawText(data.DSP_TRADENAME, {
    x: 255, // X position of the placeholder
    y: height - 105, // Y position of the placeholder
    size: 12, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font: courierBold,
    // maxWidth: width / 1.3,

    // letterSpacing: 0.5,
  });
  //
  thirtyEightPage.drawRectangle({
    x: width - 150, // X position of the background
    y: height - 135, // Y position of the background
    width: 80, // Width of the background box (adjust as needed)
    height: 13, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });
  thirtyEightPage.drawText(data.DSP_TRADENAME, {
    x: width - 150, // X position of the placeholder
    y: height - 133, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    // maxWidth: width / 1.3,

    // letterSpacing: 0.5,
  });
  thirtyEightPage.drawRectangle({
    x: 140, // X position of the background
    y: height - 315, // Y position of the background
    width: 500, // Width of the background box (adjust as needed)
    height: 30, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const fourtyText = `Other minor expenses that have been approved by an employee’s manager\n(i.e. cell phones and other tools required by ${data.DSP_TRADENAME} to perform the job.`;
  thirtyEightPage.drawText(fourtyText, {
    x: 142, // X position of the placeholder
    y: height - 295, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width / 1.3,
  });
  //   ///
  fourtyTwoPage.drawRectangle({
    x: 70, // X position of the background
    y: height - 210, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 120, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const fourtyTwoPageText = `During your employment with ${data.DSP_TRADENAME}, you may use biometric equipment, devices, systems or software (“Equipment”) that utilizes a scan of your finger, hand, face, retina, or iris or your voiceprint to record your time worked, for secure entry or exit, for security or for safety monitoring, to unlock or use the Equipment, or for other business purposes. This policy explains how the Company collects, stores, uses, discloses and destroys a scan of your finger, hand, face, retina, or iris or your voiceprint for such Equipment in compliance with the Illinois Biometric Information Privacy Act, the Texas Capture or Use of Biometric Identifiers Act, the Washington Biometric Privacy Law, the California Privacy Rights Act or other applicable law, and supplements any prior communications and policies that relate to this subject.`;
  fourtyTwoPage.drawText(fourtyTwoPageText, {
    x: 70, // X position of the placeholder
    y: height - 105, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 12,
    font,
    maxWidth: width / 1.3,
  });
  //   /////
  sixtyTwoPage.drawRectangle({
    x: 70, // X position of the background
    y: height - 342, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 70, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const sixtyTwoPageText = `This Notice covers all employees of ${data.DSP_TRADENAME}, temporary and permanent. Unless stated otherwise, our current Notice applies to all personal information we have about you, including information we collect about you through third parties we work with or provide services to, such as Amazon. You should review this Notice frequently to see recent updates.`;
  sixtyTwoPage.drawText(sixtyTwoPageText, {
    x: 70, // X position of the placeholder
    y: height - 300, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width / 1.3,
  });
  //   /////
  sixtyThree.drawRectangle({
    x: 72, // X position of the background
    y: height - 545, // Y position of the background
    width: width - 140, // Width of the background box (adjust as needed)
    height: 60, // Height of the background box (adjust as needed)
    color: rgb(1, 1, 1), // White color
  });

  const sixtyThreeText = `We share your personal information only as described below and with subsidiaries or affiliates that ${data.DSP_TRADENAME} controls that are either subject to this Notice or follow practices at least as protective as those described in this Notice`;
  sixtyThree.drawText(sixtyThreeText, {
    x: 70, // X position of the placeholder
    y: height - 500, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 14,
    font,
    maxWidth: width / 1.3,
  });
  //   // name and date
  secondPage.drawText(data.SUFFIX + data.NAME, {
    x: 72, // X position of the placeholder
    y: height - 575, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
    font: boldfont,
  });
  secondPage.drawText(data.DATE, {
    x: 72, // X position of the placeholder
    y: height - 620, // Y position of the placeholder
    size: 11, // Text size
    color: rgb(0, 0, 0),
    lineHeight: 15,
    font: boldfont,
  });
  //   //
  //   sixtySevenPage.drawText(data.globalutil?.suffixes() + data.NAME, {
  //     x: 72, // X position of the placeholder
  //     y: height - 580, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });
  //   sixtySevenPage.drawText(data.DATE, {
  //     x: 400, // X position of the placeholder
  //     y: height - 580, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });
  //   //
  //   sixtyFourPage.drawText(data.globalutil?.suffixes() + data.NAME, {
  //     x: 160, // X position of the placeholder
  //     y: height - 225, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });
  //   pages[64].drawText(data.globalutil?.suffixes() + data.NAME, {
  //     x: 220, // X position of the placeholder
  //     y: height - 225, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });
  //   pages[65].drawText(data.DATE, {
  //     x: 380, // X position of the placeholder
  //     y: height - 325, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });
  //   pages[65].drawText(data.globalutil?.suffixes() + data.NAME, {
  //     x: 260, // X position of the placeholder
  //     y: height - 380, // Y position of the placeholder
  //     size: 11, // Text size
  //     color: rgb(0, 0, 0),
  //     lineHeight: 15,
  //     font: boldfont,
  //   });

  //////

  if (data.SIGNATURE) {
    data.SIGNATURE.forEach((pathString) => {
      secondPage.drawSvgPath(pathString, {
        x: 72,
        y: height - 500,
        // color,
        // borderColor: color,
        borderWidth: 5,
        scale: 0.3,
      });
      // sixtySevenPage.drawSvgPath(pathString, {
      //   x: 72,
      //   y: height - 585,
      //   // color,
      //   // borderColor: color,
      //   borderWidth: 5,
      //   scale: 0.3,
      // });
      // pages[65].drawSvgPath(pathString, {
      //   x: 72,
      //   y: height - 275,
      //   // color,
      //   // borderColor: color,
      //   borderWidth: 5,
      //   scale: 0.3,
      // });
    });
  }
};
